export function loadExternalScript(src: string, id?: string): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    if (id && document.getElementById(id)) {
      resolve(document.getElementById(id) as HTMLScriptElement);
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (id) script.id = id;
    script.onload = () => resolve(script);
    script.onerror = (e) => reject(e);

    document.body.appendChild(script);
  });
}

export function removeExternalScript(id: string): void {
  const script = document.getElementById(id);
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
}

export function ensureStyleElement(id: string, css: string): HTMLStyleElement {
  let style = document.getElementById(id) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement('style');
    style.id = id;
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }
  return style;
}

export function removeStyleElement(id: string): void {
  const style = document.getElementById(id);
  if (style && style.parentNode) {
    style.parentNode.removeChild(style);
  }
}
